import React from "react";
import { Title } from "../Title";
import style from "./AboutUsInfo.module.css";
import background from "../../assets/our-srory-background.png";

export const AboutUsInfo = () => {
  return (
    <div
      style={{ backgroundImage: `url(${background})` }}
      className={style.aboutUsInfoContainer}
    >
      <div className={"container"}>
        <Title as="h1" color="white" title="About HomeCraft Masters" />
        <div className={style.aboutUsInfoTextContainer}>
          <p className={style.aboutUsInfoText}>
            HomeCraft Masters is a family-owned Colorado company with more than
            20 years of experience in custom kitchen design and cabinetry. Our
            Ukrainian roots bring European-inspired design, careful
            craftsmanship, and a commitment to quality into every project. We
            combine your ideas with our experience to create a kitchen that
            fits your home, lifestyle, and expectations.
          </p>
        </div>
      </div>
    </div>
  );
};
